class BlockBadgeViolator extends CustomElement {
    constructor() {
        super();

        this.state = {
            badgeText: '',
            badgeBackground: '',
            badgeColor: '',
        }
    }

    initState() {
        let badgeText = this.getAttribute(':badgeText');
        let badgeBackground = this.getAttribute(':badgeBackground');
        let badgeColor = this.getAttribute(':badgeColor');

        badgeText = !!badgeText && badgeText !== 'undefined' ? badgeText : null;
        badgeBackground = !!badgeBackground && badgeBackground !== 'undefined' ? badgeBackground : null;
        badgeColor = !!badgeColor && badgeColor !== 'undefined' ? badgeColor : null;

        this.state = {
            badgeText,
            badgeBackground,
            badgeColor,
        }
    }

    connectedCallback() {
        this.initState();
        this.render();
    }


    render() {
        const { badgeBackground, badgeText, badgeColor } = this.state;

        if (!badgeBackground && !badgeText && !badgeColor) return '';

        this.innerHTML = `
        <div class="bg-[${badgeBackground}] text-[${badgeColor}] text-[1.2rem] font-bold rounded-md flex justify-center items-center px-3 h-full">
            ${badgeText}
        </div>`
    }
}

customElements.define('product-block-badge-violator', BlockBadgeViolator)